import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'nl2br',
  standalone: true,
})
export class Nl2brPipe implements PipeTransform {
  public transform(value: string): string {
    return value.replaceAll('\n', '<br />')
  }
}
